module.exports = __webpack_public_path__ + "static/media/tag-search-bd.405752da.svg";